import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import {types}  from '@proj/static';
import { Modal } from "antd";
import * as Order from '../slices/order.slice';
import ShippingCreateError from "../../components/order/ShippingCreateError";


const commonSlice = createSlice({
    name:"common",
    initialState:{},
    reducers:{
        displayError:(state,action:PayloadAction<{key:string,error:types.commonTypes.HTTP_ERROR}>) =>{
            const displayMessage = () => {
                Modal.error({
                    title:action.payload.error?.message?.toString() || "Error Occured"
                })
            }
            switch (action.payload.key) {
                case Order.getOrderDetails.type:
                    displayMessage();
                    break;
                case Order.createShipping.type:
                    let errorMessage = action.payload.error?.message;
                    try{
                        let errorMsgJson = typeof errorMessage === 'object'?errorMessage:JSON.parse(errorMessage as string);
                        let errorComponent = ShippingCreateError(errorMsgJson);
                        Modal.error({
                            title:"Error Occured",
                            content:errorComponent
                        })
                    }
                    catch(err:any){
                        console.log(err);
                        displayMessage();
                    }
                    break;
                default:
                    displayMessage();
                    break;
            }
        }
    }
})

export const {
    displayError
} = commonSlice.actions;
export default commonSlice.reducer;